export default __webpack_public_path__ + "static/bi-date-user-filter-7ca9e9ac9da8de1e35b63441d5fdc863.mp4";